import React from 'react';
import * as XLSX from 'xlsx';

const TableTittle = ({ sectionTitle, sectionSubtitle, onAddClick, activeTab, tableRefs, onCarriersClick, onBulkEditClick }) => {
    const generateExcelReport = () => {
        const activeTable = tableRefs.current[activeTab]?.querySelector('table');
        if (activeTable) {
            // Clone the table element
            const tableClone = activeTable.cloneNode(true);
            // Ensure the cloned table has rows
            if (tableClone && tableClone.rows.length > 0) {
                const firstRow = tableClone.rows[0];
                // Ensure the first row has cells
                if (firstRow && firstRow.cells.length > 0) {
                    // Remove the Actions column from the cloned table
                    const actionColumnIndex = Array.from(firstRow.cells).findIndex(cell => cell.innerText === 'Actions');
                    if (actionColumnIndex > -1) {
                        Array.from(tableClone.rows).forEach(row => {
                            if (row.cells[actionColumnIndex]) {
                                row.deleteCell(actionColumnIndex);
                            }
                        });
                    }
                    // Generate the Excel file from the cloned table
                    const worksheet = XLSX.utils.table_to_sheet(tableClone);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, activeTab);
                    XLSX.writeFile(workbook, `${activeTab}_report.xlsx`);
                } else {
                    console.error('First row does not have cells');
                }
            } else {
                console.error('Table does not have rows');
            }
        } else {
            console.error('No table found for the active tab');
        }
    };

    return (
        <div className="row space__between">
            <div className="section__header">
                <h2 className="section__title">{sectionTitle}</h2>
                <p className="section__subtitle">{sectionSubtitle}</p>
            </div>
            <div className="section__buttons">
                <button className="btn btn__green" onClick={onAddClick}>
                    <svg className="icon icon-add" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref="#addBtn"></use>
                    </svg>
                    Add
                </button>
                {onBulkEditClick && (
                    <button className="btn btn__white_g" onClick={onBulkEditClick}>
                        <svg className="icon icon-edit" width="16" height="16" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <use xlinkHref="#edit"></use>
                        </svg>
                        Bulk Edit
                    </button>
                )}
                {activeTab === 'amazon-shipments' && onCarriersClick && (
                    <button className="btn btn__white_g" onClick={onCarriersClick}>
                        Carriers
                    </button>
                )}
                <button className="btn btn__white_g" onClick={generateExcelReport}>
                    <svg className="icon icon-download" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref="#download"></use>
                    </svg>
                    Download Excel Report
                </button>
            </div>
        </div>
    );
};

export default TableTittle;
